/** Safe segment for filesystem names (lowercase, hyphens). */
export const slugDownloadSegment = (value: string, maxLen = 32): string =>
  String(value || '')
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, maxLen) || 'banner';

export type BuildDownloadFileNameOptions = {
  extension: string;
  bannerType?: string;
  entity?: string;
  templateId?: string | number | null;
  at?: Date;
};

/**
 * e.g. respark-large_banner-devourin-template-42-2026-06-04-153045.jpeg
 */
export const buildDownloadFileName = ({
  extension,
  bannerType,
  entity,
  templateId,
  at = new Date(),
}: BuildDownloadFileNameOptions): string => {
  const pad = (n: number) => String(n).padStart(2, '0');
  const stamp = [
    at.getFullYear(),
    pad(at.getMonth() + 1),
    pad(at.getDate()),
    `${pad(at.getHours())}${pad(at.getMinutes())}${pad(at.getSeconds())}`,
  ].join('-');

  const parts = ['respark', slugDownloadSegment(bannerType || 'banner')];
  if (entity) {
    parts.push(slugDownloadSegment(entity));
  }
  if (templateId != null && templateId !== '' && templateId !== 0) {
    parts.push('template', slugDownloadSegment(String(templateId), 24));
  }
  parts.push(stamp);

  let ext = extension.replace(/^\./, '').toLowerCase();
  if (ext === 'jpg') {
    ext = 'jpeg';
  }

  return `${parts.join('-')}.${ext}`;
};

export default buildDownloadFileName;
